"use client";
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ seoData }) => {
  const defaultTitle = "Find Affordable Quality Care Abroad | Fitsib";
  const defaultDescription =
    "Discover affordable medical treatments abroad with Fitsib. Compare hospitals, treatments, and doctors worldwide.";
  const defaultImage =
    "https://d2fj4tw1j25ivs.cloudfront.net/assets/logos/logo.jpg";
  const defaultUrl = "https://www.fitsib.com/";
  const defaultOgTitle =
    "Fitsib - Your Gateway to World-Class Medical Treatment Abroad";

  return (
    <Helmet>
      <title>{seoData?.metaTitle || defaultTitle}</title>
      <meta
        name="description"
        content={seoData?.metaDescription || defaultDescription}
      />
      <meta
        name="keywords"
        content={
          seoData?.keywords ||
          "medical treatment, healthcare abroad, affordable healthcare"
        }
      />
      <meta
        property="og:title"
        content={seoData?.metaSocial?.[0]?.title || defaultOgTitle}
      />
      <meta
        property="og:description"
        content={seoData?.metaSocial?.[0]?.description || defaultDescription}
      />
      <meta
        property="og:image"
        content={seoData?.metaSocial?.[0]?.image?.url || defaultImage}
      />
      <meta
        property="og:url"
        content={seoData?.metaSocial?.[0]?.socialpageurl || defaultUrl}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fitsib" />
      <meta name="twitter:creator" content="@fitsib" />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default SEO;
